// standardLabel turns a Security Hub standard id like
// "standards/pci-dss/v/4.0.1" into a readable label "PCI DSS v4.0.1".
// Mirrors the backend standardDisplayName so the UI shows the same names.
export const standardLabel = (id) => {
  if (!id) return '';
  const i = id.indexOf('/v/');
  const v = i >= 0 ? id.slice(i + 3) : '';
  const withVer = (n) => (v ? `${n} v${v}` : n);
  if (id.includes('aws-foundational-security-best-practices')) return withVer('AWS Foundational Security Best Practices');
  if (id.includes('cis-aws-foundations-benchmark')) return withVer('CIS AWS Foundations Benchmark');
  if (id.includes('nist-800-53')) return withVer('NIST 800-53');
  if (id.includes('nist-800-171')) return withVer('NIST 800-171');
  if (id.includes('pci-dss')) return withVer('PCI DSS');
  if (id.includes('aws-resource-tagging-standard')) return withVer('AWS Resource Tagging Standard');
  return id;
};
